import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import CheckBox from '../../../../../../../common/components/Checkbox';
import { StoreState } from '@mm/state/store-interfaces';
import ConnectedPageCRUDActions from '@mm/state/actions/ConnectedPageCRUDActions';

export const NotificationSettings = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const connectedPage = useSelector(
    (state: StoreState) => state.connectedPage.pageDetails,
  );

  const onDailyLeadToggle = () => {
    if (connectedPage && connectedPage.mailingSettings) {
      dispatch(
        ConnectedPageCRUDActions.update({
          ...connectedPage,
          mailingSettings: {
            leadsEmail: !connectedPage.mailingSettings.leadsEmail,
          },
        }),
      );
    }
  };

  const onUserNotificationToggle = () => {
    if (connectedPage) {
      dispatch(
        ConnectedPageCRUDActions.update({
          ...connectedPage,
          notificationsEnabled: !(
            connectedPage && connectedPage.notificationsEnabled
          ),
        }),
      );
    }
  };

  return (
    <div className="bot-publishing-pane__list-item">
      <span className="bot-publishing-pane__logo-item-text">
        Notification Settings
      </span>
      <div>
        <CheckBox
          isChecked={!!connectedPage?.notificationsEnabled}
          onToggle={onUserNotificationToggle}
          label="Send MobileMonkey users notifications from this Facebook Page"
        />

        <CheckBox
          isChecked={!!connectedPage?.mailingSettings?.leadsEmail}
          onToggle={onDailyLeadToggle}
          label="Receive MobileMonkey daily leads email"
        />
      </div>
    </div>
  );
};
